export default function AlertBanner() {
  return (
    <div className="bg-[#f59e0b] text-black py-3 px-4 sm:px-6 text-center font-medium text-xs sm:text-sm md:text-base mt-[72px]">
      <span className="inline-flex items-start sm:items-center gap-2">
        <i className="ri-alert-line text-base sm:text-lg mt-0.5 sm:mt-0 flex-shrink-0"></i>
        <span>
          <strong>Advisory:</strong> Your Assets, Your Business, and Your Estate Are Running Without a Defense Plan.
        </span>
      </span>
    </div>
  );
}
